/* App download column. Markup: snippets/app-download-column.liquid */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('app-download')) return;

  class AppDownload extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.addEventListener('click', this);
      this.addEventListener('keydown', this);
    }

    get tabs() {
      return Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
    }

    handleEvent(event) {
      const tab = event.target && event.target.closest ? event.target.closest('[role="tab"]') : null;
      if (!tab || !this.contains(tab)) return;

      if (event.type === 'click') {
        this.select(tab);
      } else if (event.type === 'keydown') {
        this.onKeydown(event, tab);
      }
    }

    /* iPhone is selected by default; selecting one platform deselects the other. */
    select(tab) {
      const platform = tab.getAttribute('data-platform');
      if (!platform || this.getAttribute('data-active') === platform) return;

      this.setAttribute('data-active', platform);

      this.tabs.forEach(function (item) {
        const isSelected = item === tab;
        const panel = document.getElementById(item.getAttribute('aria-controls'));

        item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        item.setAttribute('tabindex', isSelected ? '0' : '-1');

        if (panel) {
          if (isSelected) {
            panel.removeAttribute('inert');
          } else {
            panel.setAttribute('inert', '');
          }
        }
      });
    }

    onKeydown(event, tab) {
      const list = this.tabs;
      const last = list.length - 1;
      let index = list.indexOf(tab);

      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          index = index === last ? 0 : index + 1;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          index = index === 0 ? last : index - 1;
          break;
        case 'Home':
          index = 0;
          break;
        case 'End':
          index = last;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.select(list[index]);
      list[index].focus();
    }
  }

  window.customElements.define('app-download', AppDownload);

  /* Publishes badge and QR clicks for any custom pixel that subscribes to "app_download_click".
     QR scans happen on the visitor's phone, so they cannot be seen from this page. */
  document.addEventListener('click', function (event) {
    const link = event.target && event.target.closest ? event.target.closest('[data-app-dl-link]') : null;
    if (!link) return;

    try {
      const analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        analytics.publish('app_download_click', {
          platform: link.getAttribute('data-platform'),
          surface: link.getAttribute('data-surface'),
          placement: 'footer'
        });
      }
    } catch (error) {
      /* Tracking must never block navigation. */
    }
  });
})();
